<template>
<v-app>
  <v-snackbar
        v-model="snackWithButtons"
        :timeout="timeout"
        top
        centered
      >
        {{ snackWithBtnText }}
        <v-spacer />
        <v-btn
          dark
          text
          color="#F66B24"
          @click.stop="refreshApp"
        >
          {{ snackBtnText }}
        </v-btn>
        <v-btn
          dark
          icon
          @click="snackWithButtons = false"
        >
          close
        </v-btn>
      </v-snackbar>
      <router-view />
</v-app>
</template>

<script>
export default {
  name: 'App',
   watch: {
      '$route' (to) {
        document.title = to.meta.title || 'ONE'
      }
    },

  data: () => ({
      refreshing: false,
      registration: null,
      snackBtnText: '',
      snackWithBtnText: '',
      snackWithButtons: false,
      timeout: -1,
  }),
  methods: {
    showRefreshUI (e) {
      this.registration = e.detail;
      this.snackBtnText = 'Refresh';
      this.snackWithBtnText = 'New version available!';
      this.snackWithButtons = true;
    },
    refreshApp () {
        // this.snackWithButtons = false;
        // Protect against missing registration.waiting.
        if (!this.registration || !this.registration.waiting) { 
            this.snackBtnText = "ERROR"
          return; 
          }else{
                    this.registration.waiting.postMessage('skipWaiting');
                     this.snackWithButtons = false;

          }
      },
  },
  created: function (){
        // Listen for swUpdated event and display refresh snackbar as required.
    document.addEventListener('swUpdated', this.showRefreshUI, { once: true });
    // Refresh all open app tabs when a new service worker is installed.
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (this.refreshing) return;
      this.refreshing = true;
      window.location.reload();
    });

  }
};
</script>
